export const EARLIEST_PROJECT_DATE = "01/01/2015";
export const MILESTONES = {
  PTO: "PTO",
  PERMISSION_TO_OPERATE: "Permission to Operate",
  PROJECT_START: "Project Start",
  PROJECT_INTAKE: "Project Intake",
  PROPOSAL_REQUESTED: "Proposal Requested",
  PROPOSAL_GENERATED: "Proposal Generated",
  PROJECT_CONFIRMATION: "Project Confirmation",
  SITE_SURVEY_COMPLETED: "Site Survey Completed",
  DESIGN_COMPLETED: "Design Completed",
  NEW: "New",
};
export const STAGES = {
  QUALIFIED: "Qualified",
  PROPOSAL_REQUESTED: "Proposal Creation",
  PROPOSAL_PRESENTED: "Proposal Presentation",
  CONTRACT_SIGNED: "Contract Signed",
  PROJECT_CONFIRMATION: "Project Confirmation",
  DESIGN: "Design",
  PERMITTING: "Permitting",
};
export const ACTIVITIES = {
  PTO_APPLICATION_SUBMITTED: "PTO Application Submitted",
};

export const CERTIFICATION_TIER = {
  SETTER: 1,
  SALES_PRO: 2,
  CLOSER: 3,
};
